import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_4 = { class: "card-title mt-0" }

import getAuditLogsQueryParameter from '@/types/requests/getAuditLogs';
import AuditLogList from '@/components/AuditLog/AuditLogList.vue';
import getAuditLogsResponse from '@/types/responses/getAuditLogs';
import { AUDITABLE_TYPES } from "@/services/consts/audit_logs";
import SearchForm from '@/components/AuditLog/SearchForm.vue';
import { useAuth } from "@/services/user/Auth0UserProvider";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import { formatDate } from "@/services/functions";
import Api from "@/services/api/ApiServiceFabrick";
import auditLog from '@/types/responses/auditLog';
import { Ref, ref, reactive, watch } from "vue";
import i18n from "@/lang/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditLog',
  setup(__props) {

document.title = i18n.global.t('pages.auditLog.title');
const { loginWithRedirect } = useAuth()
const totalPage: Ref<number> = ref(0)
const itemsPerPage: Ref<number> = ref(50)
const allElementsCount: Ref<number> = ref(0)
const currentPage: Ref<number> = ref(1)
const isLoading: Ref<boolean> = ref(false)
const auditLogs: Ref<auditLog[]> = ref([])
const isSearchCompleted: Ref<boolean> = ref(false)
const searchParams: getAuditLogsQueryParameter = reactive({
  page: 1,
  auditable_type: null,
  auditable_id: null,
  event: '',
  operation_office_id: null,
  user_id: null,
  daterange: ''
})
const errors = reactive({
  operation_office_id: [] as string[],
  daterange: [] as string[]
})

function getAuditLogs() {
  isLoading.value = true
  Api().getAuditLogs(searchParams).then((data: getAuditLogsResponse) => {
    auditLogs.value = data.data
    totalPage.value = data.total_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
    currentPage.value = data.current_page
    isSearchCompleted.value = true
  }).catch((error) => {
    errorHandler(error)
  }).finally(() => {
    isLoading.value = false
  })
}

function errorHandler(error: any) {
  const errorResponse = error.response
  if (errorResponse.status === 422) {
    errors.operation_office_id = errorResponse.data.errors?.operation_office_id
  }
  if (errorResponse.status === 403) {
    loginWithRedirect()
  }
}

function searchList(values: any) {
  clearValidation()
  searchParams.page = values.page
  searchParams.auditable_type = values.auditable_type ? [values.auditable_type] : Object.keys(AUDITABLE_TYPES).flat()
  searchParams.auditable_id = values.auditable_id ? values.auditable_id : null
  searchParams.event = values.event ? values.event : ''
  searchParams.operation_office_id = values.operationOffice ? values.operationOffice.id : null
  searchParams.user_id = values.account ? values.account.id : null
  searchParams.daterange = values.daterange ? `${formatDate(values.daterange[0], '/')} - ${formatDate(values.daterange[1], '/')}` : ''
  getAuditLogs()
}

function clearValidation() {
  errors.operation_office_id = []
  errors.daterange = []
}

watch(currentPage, () => {
  searchParams.page = currentPage.value
  getAuditLogs()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.auditLog.title')), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(AuditLogList, {
          class: "mb-2",
          isLoading: isLoading.value,
          isSearchCompleted: isSearchCompleted.value,
          auditLogs: auditLogs.value
        }, null, 8, ["isLoading", "isSearchCompleted", "auditLogs"]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          itemsPerPage: itemsPerPage.value,
          allElementsCount: allElementsCount.value,
          showItemCount: true
        }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"])
      ])
    ]),
    _createVNode(SearchForm, {
      isLoading: isLoading.value,
      errors: errors,
      onSearch: searchList
    }, null, 8, ["isLoading", "errors"])
  ]))
}
}

})